import { useRef } from "react";
import { useInView } from "framer-motion";
import { Link } from "react-router-dom";
import bakeryImg from "@/assets/bakery.webp";
import GeometricOverlay from "./GeometricOverlay";
import WordFadeIn from "./WordFadeIn";
import DrawIcon from "./DrawIcon";
import { motion } from "framer-motion";

const categories = [
  {
    title: "Obst & Gemüse",
    desc: "Saisonales und regionales Obst und Gemüse, Bioware, frische Kräuter und exotische Früchte.",
    image: "/images/obstbereich.webp",
  },
  {
    title: "Bäckerei Wiehler & Bake-Off",
    desc: "Backwaren der Bäckerei Wiehler aus Meerbusch sowie täglich frisch aufgebackene Artikel aus dem Bake-Off-Bereich.",
    image: bakeryImg,
  },
];

const SortimentSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="sortiment" className="relative py-20 md:py-32 px-6 md:px-16" ref={ref} aria-label="Unser Sortiment">
      {/* Decorative drawn icon */}
      <DrawIcon
        variant="cart"
        size={160}
        delay={0.3}
        className="absolute left-1/2 -translate-x-1/2 top-8 md:top-12 z-10 opacity-20"
      />

      <div className="text-center md:text-left">
        <p className="font-body text-sm text-primary-bright tracking-[0.3em] uppercase mb-4">
          Unser Sortiment
        </p>
        <WordFadeIn
          text="Mehr als nur ein Supermarkt"
          as="h2"
          className="font-display text-3xl sm:text-4xl md:text-6xl font-bold text-foreground leading-tight max-w-3xl mx-auto md:mx-0 [hyphens:none]"
          staggerDelay={0.1}
        />
      </div>

      <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-6">
        {categories.map((cat, i) => (
          <motion.div
            key={cat.title}
            initial={{ opacity: 0, y: 60 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 + i * 0.2 }}
            className="group relative h-[60vh] md:h-[70vh] overflow-hidden cursor-pointer"
          >
            <img
              src={cat.image}
              alt={cat.title}
              className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/30 to-transparent" />
            <GeometricOverlay />

            <div className="relative z-20 flex flex-col justify-end h-full p-6 md:p-12 text-center md:text-left">
              <h3 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-foreground [hyphens:none]">
                {cat.title}
              </h3>
              <p className="mt-3 text-muted-foreground font-body max-w-md mx-auto md:mx-0 leading-relaxed">
                {cat.desc}
              </p>
              <Link
                to="/produkte"
                className="mt-6 inline-flex items-center justify-center md:justify-start gap-2 text-primary-bright font-display text-sm tracking-wide group/link focus:outline-none focus:ring-2 focus:ring-ring rounded"
              >
                <span>Mehr erfahren</span>
                <span className="inline-block transition-transform duration-300 group-hover:translate-x-2" aria-hidden="true">
                  →
                </span>
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default SortimentSection;